module.exports = __webpack_public_path__ + "static/media/logos.2412e7d7.svg";